import { apiUTCToLocalDateTime } from "@jugl-web/utils";
import addHours from "date-fns/addHours";
import differenceInSeconds from "date-fns/differenceInSeconds";

export const getChatSecondsToExpiration = (sinceDate?: string | null) => {
  if (!sinceDate) return 0;

  return differenceInSeconds(
    addHours(new Date(apiUTCToLocalDateTime(sinceDate)), 24),
    new Date()
  );
};
